// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cMMSu","rootNoMargin":"styles_rootNoMargin__36Gut"};